import { render, staticRenderFns } from "./BaseRange.vue?vue&type=template&id=97918c64&"
import script from "./BaseRange.vue?vue&type=script&lang=js&"
export * from "./BaseRange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports